/*
 * The 404 page.
 *
 * ☠️ It exists because of what the cutover deleted. `/law/:id`, `/laws/:initiative`,
 * `/categories/:category`, `/themes/:theme` and `/search` were the previous implementation's
 * URLs and are gone — and a one-to-one `/law/:id` → `/vorgang/:id` redirect was possible (the
 * ids are identical) and was declined by the owner on 2026-09-13.
 *
 * That decision is only defensible if the dead end explains itself, because those links are
 * shared and will keep arriving. ⚠️ Note this still improves on the state it replaces: before
 * the cutover an old URL returned 200, rendered the shell, and *then* failed its API calls —
 * a page that appears and then breaks is worse than an honest 404.
 */

import { Link } from 'react-router';
import './notfound.css';

// The real destinations, not a sitemap. Each is where one class of dead URL used to lead:
// `/law/:id` and `/laws/:initiative` to a bill, `/categories` and `/themes` to a topic,
// `/search` to the list that is now the way in.
const DESTINATIONS = [
    { to: '/', label: 'Diese Woche', hint: 'Die letzte Sitzungswoche auf einen Blick' },
    { to: '/gesetze', label: 'Gesetzentwürfe', hint: 'Alle 419 Entwürfe dieser Wahlperiode, filterbar' },
    { to: '/themen', label: 'Themen', hint: 'Zehn Politikfelder, je ein Dossier' },
    { to: '/parteien', label: 'Fraktionen', hint: 'Was eine Fraktion tatsächlich einbringt' },
];

export default function NotFound() {
    return (
        <div className="dq-page dq-notfound">
            <p className="dq-notfound__code">404</p>
            <h2 className="dq-notfound__heading">Diese Seite gibt es nicht.</h2>
            <p className="dq-notfound__lead">
                Möglicherweise stammt der Link aus der früheren Version von Democratiq.
                Deren Adressen — etwa <code>/law/…</code>, <code>/categories/…</code> oder
                {' '}<code>/search</code> — wurden abgeschaltet. Die Inhalte gibt es weiterhin,
                unter neuen Adressen.
            </p>
            <nav className="dq-notfound__nav" aria-label="Weiter zu">
                <ul className="dq-notfound__list">
                    {DESTINATIONS.map((item) => (
                        <li key={item.to}>
                            <Link className="dq-notfound__link dq-tap" to={item.to}>
                                <span className="dq-notfound__label">{item.label}</span>
                                <span className="dq-notfound__hint">{item.hint}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
}
